export const COLORS = {
	textLightGrey: '#888B90',
	textLightGray: '#888B90',
	textDarkGray: '#888B90',
	textDarkGrey: '#888B90',
	darkBg: '#09021d',
	drawerBg: '#2b2b2b',
	darkBox: '#343434',
	darkBoxOpacity: '#34343422',
	lightBg: '#D9DFFF',
	white: '#ffffff',
	whiteOpacity: 'rgba(255, 255, 255, 0.8)',
	blackOpacity: 'rgba(0, 0, 0, 0.8)',
	blackCardOpacity: 'rgba(0,0,0,0.4)',
	whiteCardOpacity: 'rgba(255,255,255,0.4)',
	black: '#0D0E0F',
	darkGray: '#1C1C1C',
	point: '#00499F',
	darkGrey: '#333333',
	lightGrey: '#e9e9e9',
	lightGray: '#eee',
	lightSilver: '#888b90',
	onSecondary: '#EDEFF1',
	complementary: '#ffffff',
	darkBorder: '#ccc',
	lightBorder: '#555',
	subHeaderDark: '#242424',
	subHeaderLight: '#FBFBFB',
	shadowDark: '#333',
	shadowLight: '#eee',
}
export const theme: {
	light: { COLORS: any }
	dark: { COLORS: any }
} = {
	light: {
		COLORS: {
			background: COLORS.darkBg,
			bgColor: COLORS.black,
			drawerBgColor: COLORS.drawerBg,
			mdrawerBgColor: '#343140',
			tradeBG: '#171B26',
			mitBG: '#171B26',
			opacityBgColor: COLORS.blackOpacity,
			descBox: COLORS.darkBox,
			textsilver: COLORS.lightSilver,
			gray: COLORS.darkGray,
			grey: COLORS.darkGrey,
			textw: '#EFEFEF',
			stroke: '#2F2F2F',
			Secondary: '#EFEFEF',
			Tertiary: '#DFDFDF',
			onSecondary: '#CBD1D7',
			onTertiary: '#000000',
			fail_sub: '#333E45',
			Prinary: '#ffffff',
			raise_sub: '#603736',
			point: '#00499F',
			complementary: '#1D1D1D',
			fail: '#007EDA',
			raise: '#F05551',
			textGrey: COLORS.textLightGrey,
			textGray: COLORS.textLightGrey,
			borderColor: COLORS.lightBorder,
			descBorder: COLORS.darkBorder,
			header: COLORS.darkGray,
			subHeader: COLORS.subHeaderDark,
			shadow: COLORS.shadowDark,
			cardOpacity: COLORS.blackCardOpacity,
		},
	},
	dark: {
		COLORS: {
			background: COLORS.lightBg,
			drawerBgColor: COLORS.white,
			mdrawerBgColor: COLORS.white,
			tradeBG: COLORS.white,
			mitBG: '#f3f3f3',
			opacityBgColor: COLORS.whiteOpacity,
			descBox: COLORS.darkBoxOpacity,
			onTertiary: '#F2F4F6',
			fail_sub: '#E0F2FF',
			fail: '#007EDA',
			raise: '#F05551',
			raise_sub: '#FFEDED',
			bgColor: COLORS.white,
			stroke: '#EAEAEA',
			onSecondary: '#EDEFF1',
			Prinary: '#303030',
			textsilver: COLORS.lightSilver,
			point: '#00499F',
			gray: COLORS.lightGray,
			grey: COLORS.lightGrey,
			textw: '#3A3A3A',
			Tertiary: '#7D7D7D',
			Secondary: '#3A3A3A',
			textGrey: COLORS.textLightGrey,
			textGray: COLORS.textLightGrey,
			borderColor: COLORS.darkBorder,
			descBorder: COLORS.lightBorder,
			header: COLORS.white,
			subHeader: COLORS.subHeaderLight,
			shadow: COLORS.shadowLight,
			cardOpacity: COLORS.whiteCardOpacity,
		},
	},
}

export const NAME = 'THEBIT'
